// Controls whether a user is shown a dialog before they can leave the app
// to prevent accidental navigations and lost progress
let promptBeforeUnload = true

export function setPromptBeforeUnload(value: boolean) {
  promptBeforeUnload = value
}

export function shouldPromptBeforeUnload() {
  return promptBeforeUnload
}
